import { render } from "./transferManage.vue?vue&type=template&id=7f006d6f&scoped=true"
import script from "./transferManage.vue?vue&type=script&lang=js"
export * from "./transferManage.vue?vue&type=script&lang=js"

import "./transferManage.vue?vue&type=style&index=0&id=7f006d6f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f006d6f"

export default script